import { Injectable } from "@angular/core";
import { TimeoutData } from "../model/timeout-data";

@Injectable()
export class TimeoutService {

    private timeoutData: TimeoutData;

    constructor( ) {}

    public getTimeoutData() {
        return this.timeoutData;
    }

    public setTimeoutData(timeoutData: TimeoutData) {
        this.timeoutData = timeoutData;
    }
}